export const LICENSE_TYPE = {
  APP: 1,
  API: 2,
}
